<template>
  <div class="split"></div>
</template>

<script type="text/ecmascript-6">
  export default{};
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .split
    width:100%;
    height:16px
    border-top:solid 1px rgba(7,17,27,0.1)
    border-bottom:solid 1px rgba(7,17,27,0.1)
    background-color:#f3f5f7
</style>



// WEBPACK FOOTER //
// split.vue?8ea91cc6